export default __webpack_public_path__ + "static/media/top_con_cornetas.9f7eb930.png";